import React from 'react'
import * as ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './app/app'

declare global {
   interface Window {
      dataLayer: any
      analytics: any
      DocuSign: any
   }
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
   <BrowserRouter>
      <App />
   </BrowserRouter>
)
